import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, of, switchMap, tap } from 'rxjs';
import { SolarWindsService } from '../../../../../services/solar-winds.service';
import { InputMode } from '../../../../../core/editable-fields/text-input/text-input.component';


@Component({
    selector: 'recording-approval-modal',
    templateUrl: './recording-approval-modal.component.html',
    styleUrls: ['./recording-approval-modal.component.scss'],
    standalone: false
})
export class RecordingApprovalModalComponent implements OnInit {
    @Input() request: any;
    public isSubmitting: boolean = false;

    public updateRequest: any = {
        errors$: new BehaviorSubject({}),
        warnings$: new BehaviorSubject({}),
        message: '',
        onChange: () => null,
        validate: () => null,
    }

    public submitTicket$: Subject<any> = new Subject<any>;

    public get inputMode(): typeof InputMode {
        return InputMode;
    }

    constructor(
        public activeModal: NgbActiveModal,
        public toastr: ToastrService,
        public appService: SolarWindsService,
    ) {}

    public ngOnInit(): void {}

    public approveRequest(isApproved: boolean) {
        this.isSubmitting = true;
        let formData = new FormData();

        let toSubmit: any = {
            incidentId: this.request.id,
            incidentNumber: this.request.number,
            isApproved: isApproved,
            message: this.updateRequest.message,
        }

        formData.append('request', JSON.stringify(toSubmit));
        this.submitTicket$.next(formData);
    }

    public submit$ = this.submitTicket$.pipe(
        switchMap((data) => {
            this.isSubmitting = true;
            return this.appService.updateRecording$(data)
        }),
        tap((result) => {
            if (result?.IsSucceeded) {
                this.toastr.success("Class recording request successfully updated.");
                this.activeModal.close();
            }
            else {
                let message = "There was an error submitting your update.";

                //  todo:  we end up with this pattern a lot.  maybe add a shared resources for this?
                if (result.error?.Message)
                    message = result.error.Message;

                if (result?.error)
                    message = result.error;

                this.toastr.error(message);
            }

            this.isSubmitting = false;
        }
        ),
    )
}
